import React, { useState } from 'react'
import EmailVerificationEnvelopeIllustration from './EmailVerificationEnvelopeIllustration'

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

// Shared screen for both the "I use a different email now" (Flow A) and
// "add backup email" (Flow B) steps: collects an address. Re-auth (password,
// or Google/Apple) is handled separately by ReauthenticationModal when the
// API responds with a 403 reauth_required.
const EmailVerificationEmailPasswordForm = (props) => {
  const {
    title, description, emailLabel, submitLabel, currentEmail, showIllustration,
    duplicateEmailError, submitLoading, errorMessage, onSubmit, onBack, backLabel,
    onSkip, skipLabel, skipLoading,
  } = props
  const [email, setEmail] = useState('')
  const [validationError, setValidationError] = useState('')

  function handleSubmit(e) {
    e.preventDefault()
    const trimmedEmail = email.trim()
    if (!EMAIL_REGEX.test(trimmedEmail)) {
      setValidationError('Please enter a valid email address.')
      return
    }
    if (currentEmail && trimmedEmail.toLowerCase() === currentEmail.toLowerCase()) {
      setValidationError(duplicateEmailError)
      return
    }
    setValidationError('')
    onSubmit({ email: trimmedEmail })
  }

  return (
    <div className='emailVerificationFlow-form'>
      {onBack && (
        <button type='button' className='emailVerificationFlow-backBtn' onClick={onBack}>
          {backLabel || '← Back'}
        </button>
      )}
      {showIllustration && <EmailVerificationEnvelopeIllustration />}
      <div className='emailVerificationFlow-title'>{title}</div>
      {description && (
        <div className='emailVerificationFlow-description'>{description}</div>
      )}
      <form className='emailVerificationFlow-form-main' onSubmit={handleSubmit}>
        <label className='emailVerificationFlow-form-label' htmlFor='emailVerificationFlow-emailInput'>
          {emailLabel || 'Email address'}
        </label>
        <input
          id='emailVerificationFlow-emailInput'
          className='emailVerificationFlow-form-input'
          type='email'
          autoComplete='email'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoFocus
        />
        {(validationError || errorMessage) && (
          <div className='emailVerificationFlow-error'>{validationError || errorMessage}</div>
        )}
        <button type='submit' className='btn btn--blue btn--large' disabled={submitLoading}>
          {submitLoading ? 'Sending...' : (submitLabel || 'Send me a code')}
        </button>
      </form>
      {onSkip && (
        <div className='emailVerificationFlow-form-links'>
          <button
            type='button'
            className='emailVerificationFlow-linkBtn'
            onClick={onSkip}
            disabled={skipLoading}
          >
            {skipLabel || 'Not now'}
          </button>
        </div>
      )}
    </div>
  )
}

EmailVerificationEmailPasswordForm.defaultProps = {
  showIllustration: true,
  duplicateEmailError: 'Please enter a different email address.',
}

export default EmailVerificationEmailPasswordForm
